import { Component, OnInit } from '@angular/core';
import { CookieConsentService } from '../../services/cookie-consent.service';


@Component({
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss'],
})
export class CookieBannerComponent implements OnInit {
  isVisible = false;
  showSettings = false;

  analytics = false;
  marketing = false;

  constructor(private readonly cookieConsentService: CookieConsentService) {}

  ngOnInit(): void {
    this.isVisible = !this.cookieConsentService.hasConsentDecision();
  }

  acceptAll(): void {
    this.cookieConsentService.acceptAll();
    this.isVisible = false;
  }

  rejectAll(): void {
    this.cookieConsentService.rejectAll();
    this.isVisible = false;
  }

  saveCustom(): void {
    this.cookieConsentService.saveCustom({
      analytics: this.analytics,
      marketing: this.marketing,
    });

    this.isVisible = false;
  }

  openSettings(): void {
    this.showSettings = true;
  }

  closeSettings(): void {
    this.showSettings = false;
  }
}
